<template>

  <QualitaFirmatari />

</template>

<script>
import QualitaFirmatari from '../components/pratiche/QualitaFirmatari.vue'

export default {
  components: {
    QualitaFirmatari
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
